import { Icon } from './Icon'

/**
 * The way out of an inner view: an arrow at the top left of the screen, nothing else (apps/app/DESIGN.md,
 * "Back"). `label` says where it goes, for assistive technology and the tooltip, when that is known (the editor returns to
 * wherever the note was opened from). With `href` it is a link, for a way out that is a page address. The note editor on a
 * phone keeps its round Done button at the bottom instead.
 */
export function BackButton({ label, onClick, href, disabled, className = '' }: { label?: string; onClick?: () => void; href?: string; disabled?: boolean; className?: string }) {
  const name = label ? `Back to ${label}` : 'Back'
  const classes = `btn btn-ghost btn-square back-button ${className}`.trim()
  if (href) return <a className={classes} href={href} aria-label={name} title={name} onClick={onClick}><Icon name="arrow-left"/></a>
  return <button type="button" className={classes} aria-label={name} title={name} disabled={disabled} onClick={onClick}><Icon name="arrow-left"/></button>
}
